<template>
  <section>
    <div class="shadow p-3 rounded-lg bg-white">
      <!-- <h3 class="font-bold text-gray-dark mb-3">Integrations</h3> -->
      <div
        class="pt-0 py-3 px-1 lg:px-8 xl:px-4 "
      >
        <h3 class="mb-2 font-semibold md:text-2xl text-lg">Integrations</h3>
        <div class="shadow-lg bg-white p-8 rounded-lg mb-4">
          <div class="flex justify-between">
            <div class="flex items-center">
              <div class="bg-blue-royal rounded-md">
                <img :src="require(`@/assets/svg/Zoom.svg`)" class="w-10" alt="Zoom.svg" />
              </div>
              <p class="font-semibold text-lg ml-4 flex flex-col">
                Zoom
                <span class="text-green-light text-sm" v-if="zoomAdded">
                  Connected
                  {{ trainerProfileDetails && trainerProfileDetails.zoomEmail }}
                </span>
                <span class="text-red-600 text-sm" v-else> Not Connected </span>
              </p>
            </div>
            <label
              for="default-toggle"
              class="inline-flex relative items-center cursor-pointer"
            >
              <input
                type="checkbox"
                value=""
                id="default-toggle"
                class="sr-only peer"
              />
              <div
                class="w-11 h-6 ring-1 relative peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700"
                :class="[zoomAdded ? 'bg-green-light' : 'bg-gray-400']"
              >
              <button
                  class="absolute h-6 w-6 bg-white rounded-full focus:outline-none"
                  :class="{ 'right-0': zoomAdded }"
                  @click="onclickZoom"
                ></button>
              </div>
            </label>
          </div>
          <div class="text-sm mt-6 tracking-wide">
            Connect Zoom to sync events, recording, meeting attendees and
            meetings chats with Fitclass. All tracked data is visible by viewing
            a past event. Relevant event data will also be synced to Event
            Analytics. Recordings can be synced to your Community's Knowledge
            Base by permissioned users.
          </div>
        </div>
        <div class="shadow-lg bg-white p-8 rounded-lg mb-4">
          <div class="flex justify-between">
            <div class="flex items-center">
              <div class="rounded-md">
                <img :src="require(`@/assets/svg/Stripe.svg`)" class="w-14" alt="Stripe.svg" />
              </div>
              <p class="font-semibold text-lg ml-4 flex flex-col">
                Stripe
                <span class="text-green-light text-sm" v-if="stripeAdded">
                  Connected
                  {{
                    trainerProfileDetails && trainerProfileDetails.stripeEmail
                  }}
                </span>
                <span class="text-red-600 text-sm" v-else> Not Connected </span>
              </p>
            </div>
            <label
              for="default-toggle"
              class="inline-flex relative items-center cursor-pointer"
            >
              <input
                type="checkbox"
                value=""
                id="default-toggle"
                class="sr-only peer"
              />
              <div
                class="w-11 h-6 ring-1 relative peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700"
                :class="[stripeAdded ? 'bg-green-light' : 'bg-gray-400']"
              >
                <button
                  class="absolute h-6 w-6 bg-white rounded-full focus:outline-none"
                  :class="{ 'right-0': stripeAdded }"
                  @click="onclickStripe"
                ></button>
              </div>
            </label>
          </div>
          <div class="text-sm mt-6 tracking-wide">
            Connect Stripe to sync events, recording, meeting attendees and
            meetings chats with Fitclass. All tracked data is visible by viewing
            a past event. Relevant event data will also be synced to Event
            Analytics. Recordings can be synced to your Community's Knowledge
            Base by permissioned users.
          </div>
        </div>
        <div class="shadow-lg bg-white p-8 rounded-lg">
          <div class="flex justify-between">
            <div class="flex items-center">
              <div class="rounded-md">
                <GoogleIcon />
              </div>
              <p class="font-semibold text-lg ml-4 flex flex-col">
                Google
                <span class="text-green-light text-sm" v-if="googleAdded">
                  Connected
                  {{ syncStatus.email }}
                </span>
                <span class="text-red-600 text-sm" v-else> Not Connected </span>
              </p>
            </div>
            <label
              for="default-toggle"
              class="inline-flex relative items-center cursor-pointer"
            >
              <input
                type="checkbox"
                value=""
                id="default-toggle"
                class="sr-only peer"
              />
              <div
                class="w-11 h-6 ring-1 relative peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700"
                :class="[googleAdded ? 'bg-green-light' : 'bg-gray-400']"
              >
                <button
                  class="absolute h-6 w-6 bg-white rounded-full focus:outline-none"
                  :class="{ 'right-0': googleAdded }"
                  @click="onclickGoogle"
                ></button>
              </div>
            </label>
          </div>
          <div class="text-sm mt-6 tracking-wide">
            Connect Google to sync events, recording, meeting attendees and
            meetings chats with Fitclass. All tracked data is visible by viewing
            a past event. Relevant event data will also be synced to Event
            Analytics. Recordings can be synced to your Community's Knowledge
            Base by permissioned users.
          </div>
        </div>
        <NewModal
          :title="'Remove Zoom Integration'"
          :headerClass="'text-2xl leading-8 tracking-tight font-semibold'"
          v-model="removeZoom"
        >
          <p class="flex">Are you sure you want to remove Zoom app?</p>
          <div class="flex justify-between mt-16">
            <button
              class="rounded-lg bg-white w-1/2 ring-1 ring-black py-3 font-semibold focus:outline-none"
              @click="removeZoom = !removeZoom"
            >
              Cancel
            </button>
            <button
              class="rounded-lg text-white bg-black w-1/2 py-3 font-semibold ml-4 focus:outline-none"
              @click="addRemoveZoom"
            >
              Confirm
            </button>
          </div>
        </NewModal>
        <NewModal
          :title="'Remove Stripe Integration'"
          :headerClass="'text-2xl leading-8 tracking-tight font-semibold'"
          v-model="removeStripe"
        >
          <p class="flex">
            Are you sure you want to remove Stripe integration?
          </p>
          <div class="flex justify-between mt-16">
            <button
              class="rounded-lg bg-white w-1/2 ring-1 ring-black py-3 font-semibold focus:outline-none"
              @click="removeStripe = !removeStripe"
            >
              Cancel
            </button>
            <button
              class="rounded-lg text-white bg-black w-1/2 py-3 font-semibold ml-4 focus:outline-none"
              @click="addRemoveStripe"
            >
              Confirm
            </button>
          </div>
        </NewModal>
        <NewModal
          :title="'Remove Google Integration'"
          :headerClass="'text-2xl leading-8 tracking-tight font-semibold'"
          v-model="removeGoogle"
        >
          <p class="flex">
            Are you sure you want to remove Google integration?
          </p>
          <div class="flex justify-between mt-16">
            <button
              class="rounded-lg bg-white w-1/2 ring-1 ring-black py-3 font-semibold focus:outline-none"
              @click="removeGoogle = !removeGoogle"
            >
              Cancel
            </button>
            <button
              class="rounded-lg text-white bg-black w-1/2 py-3 font-semibold ml-4 focus:outline-none"
              @click="addRemoveGoogle"
            >
              Confirm
            </button>
          </div>
        </NewModal>
      </div>
    </div>
  </section>
</template>

<script>
import { GoogleIcon } from "@/components/icons";
import NewModal from "@/components/t-components/NewModal.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TrainerProfileIntegrations",
  components: {
    NewModal,
    GoogleIcon,
  },
  data() {
    return {
      zoomAdded: false,
      removeZoom: false,
      stripeAdded: false,
      removeStripe: false,
      googleAdded: false,
      removeGoogle: false,
      url:
        "https://zoom.us/oauth/authorize?response_type=code&client_id=" +
        window.config.VUE_APP_ZOOMOAUTH_CLIENT_ID +
        "&redirect_uri=" +
        window.config.VUE_APP_APP_URL +
        "dashboard",
    };
  },
  props: [
    'callerComp'
  ],
  computed: {
    ...mapGetters(["trainerProfileDetails", "syncStatus"]),
    isAdminView () {
      return this.callerComp && this.callerComp.length && this.callerComp === 'adminProfileViewer'
    }
  },
  methods: {
    ...mapActions([
      "postZoomDisconnect",
      "postDisconnectStripe",
      "getTrainerProfileDetails",
      "getSyncStatus",
      "postOauth",
      "getSyncOff",
    ]),

    onclickZoom() {
      if (this.isAdminView) {
        return false;
      }
      if (this.zoomAdded) {
        if (this.removeZoom) {
          window.open(this.url, "_blank");
        } else {
          this.removeZoom = !this.removeZoom;
        }
      } else {
        // this.$router.push({ name: "dashboard" });
        window.open(this.url, "_blank");
      }
    },

    async addRemoveZoom() {
      await this.postZoomDisconnect();
      this.removeZoom = !this.removeZoom;
      this.zoomAdded = !this.zoomAdded;
    },

    onclickStripe() {
      if (this.isAdminView) {
        return false;
      }
      if (this.stripeAdded) {
        if (this.removeStripe) {
          window.open(this.url, "_blank");
        } else {
          this.removeStripe = !this.removeStripe;
        }
      } else {
        this.$router.push({ name: "dashboard" });
      }
    },

    onclickGoogle() {
      if (this.isAdminView) {
        return false;
      }
      if (this.googleAdded) {
        if (this.removeGoogle) {
          window.open(this.url, "_blank");
        } else {
          this.removeGoogle = !this.removeGoogle;
        }
      } else {
        // this.$router.push({ name: "dashboard" });
        this.onClickGoogleSync();
      }
    },

    async addRemoveStripe() {
      await this.postDisconnectStripe();
      this.removeStripe = !this.removeStripe;
      this.stripeAdded = !this.stripeAdded;
    },

    async addRemoveGoogle() {
      await this.getSyncOff();
      this.removeGoogle = !this.removeGoogle;
      this.googleAdded = !this.googleAdded;
    },

    async onClickGoogleSync() {
      const client = await google.accounts.oauth2.initCodeClient({
        client_id: window.config.VUE_APP_GOOGLE_CLIENT_ID,
        scope: "profile email https://www.googleapis.com/auth/calendar",
        ux_mode: "popup",
        callback: (response) => {
          this.postOauth({ code: response.code }).then(() => {
            this.getSyncStatus();
          });
        },
      });
      client && client.requestCode();
    },
    async integrationDataHandler () {
      if (!this.isAdminView) {
        await this.getTrainerProfileDetails();
        await this.getSyncStatus();
      } else {
        const roleId = this.$route.params.id
        roleId ? await this.$store.dispatch('getAdminTrainerIntegrations', roleId) : ''
      }
      this.zoomAdded =
        this.trainerProfileDetails && this.trainerProfileDetails.zoomAuthorized;
      this.stripeAdded =
        this.trainerProfileDetails && this.trainerProfileDetails.stripeConnected;
      this.googleAdded = this.syncStatus && this.syncStatus.is_synced;
    }
  },
  async created() {
    this.integrationDataHandler()
  },
};
</script>